$(document).ready(function() {
    if (page_info['is_guide'] === true) {
        redirect_old_links();

        function redirect_old_links () {
            const hash = window.location.hash;
            if (!hash) {
                return;
            }

            const split = hash.split('_');
            if (split.length !== 3) {
                return;
            }

            const guide_elements = ['cat', 'question'];
            const guide = split[0];
            const type = split[1];
            const id = parseInt(split[2]);

            if (
                guide !== '#guide'
                || !guide_elements.includes(type)
                || isNaN(id)
            ) {
                return;
            }

            let redirect_url = '/guide/article/' + id + '/';
            if (type === 'cat') {
                redirect_url = '/guide/category/' + id + '/';
            }
            window.location.replace(redirect_url);
        }
    }

    var arrayOfIds = $.map($(".panel-heading"), function (n, i) {
        return n.id.substring(1, 3);
    });

    var x = $("#urlid").val();
    if (x) {
        var opener = '#' + x;
        var head = $('header');
        var offset = 0;
        if (head.length){
            offset = head.outerHeight();
        }
        opener && $(opener + '.collapse').collapse('show');
        let $element_to_scroll_to = $('#f' + x);
        if (page_info['is_guide'] == true) {
            $element_to_scroll_to = $('#guide_question_' + x).parent();
            if (page_info['is_category_id']) {
                const panel_category = "guide_cat_" + x;
                $element_to_scroll_to = $('.panel-category[data-panel-category="' + panel_category + '"]');
            }
        }
        $('html, body').animate({
            scrollTop: $element_to_scroll_to.offset().top - offset
        }, 500);
    }

    $('.accordion-toggle').click(function (e) {
        e.preventDefault();
    });

    $('#faq-toggle-all').click(function () {
        $('.panel-collapse').collapse('show');
    });
    if (page_info.show_expand_all_tooltip !== undefined) {
        $('.tooltip-question-mark').tooltip('show');
        setTimeout(function () {
            $('.tooltip-question-mark').tooltip('hide');
            }, 5000);
    }

    $(document).on('click', '.faq-accordion-toggle', function () {
        if (!$(this).hasClass('collapsed')) {
            FaqQuestionClickedEvent(
                $.trim($(this).text()),             // title
                'faq page',        // placement
                page_info.experimental_faq  // is_optimized
            ).send();
        }
    });
});
